module.exports = __webpack_public_path__ + "img/filter-arrow.b1fc4789.svg";